import { render, staticRenderFns } from "./Academic.vue?vue&type=template&id=3e647b26&scoped=true&"
import script from "./Academic.vue?vue&type=script&lang=js&"
export * from "./Academic.vue?vue&type=script&lang=js&"
import style0 from "./Academic.vue?vue&type=style&index=0&id=3e647b26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e647b26",
  null
  
)

/* custom blocks */
import block0 from "./Academic.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports